import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const primaryLinks = [
  { to: '/explore', label: 'Explore' },
  { to: '/suburbs', label: 'Suburbs' },
  { to: '/compare', label: 'Compare' },
  { to: '/insights', label: 'Insights' },
  { to: '/leaderboard', label: 'Leaderboard' },
];

export default function TopNav({ onToggleTheme, theme = 'light' }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header className="top-bar" role="banner">
      <div className="top-bar__inner">
        <NavLink to="/explore" className="top-bar__brand" aria-label="RealEstats home">
          <span className="top-bar__brand-mark" aria-hidden="true">
            <img src="/realestats-logo.svg" alt="" className="top-bar__logo" decoding="async" />
          </span>
          <span className="top-bar__brand-copy">
            <span className="top-bar__wordmark">RealEstats</span>
            <span className="top-bar__strapline">Sydney property intelligence</span>
          </span>
        </NavLink>

        <button
          type="button"
          className="top-bar__menu-toggle"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          aria-label={menuOpen ? 'Close navigation' : 'Open navigation'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <span />
          <span />
        </button>

        <nav
          id="primary-navigation"
          className={`primary-nav${menuOpen ? ' primary-nav--open' : ''}`}
          aria-label="Primary"
        >
          <ul className="primary-nav__list">
            {primaryLinks.map((link) => (
              <li className="primary-nav__item" key={link.to}>
                <NavLink
                  to={link.to}
                  className={({ isActive }) => `primary-nav__link${isActive ? ' active' : ''}`}
                >
                  {link.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="top-bar__actions">
          {onToggleTheme ? (
            <button
              type="button"
              className="top-bar__theme-toggle"
              onClick={onToggleTheme}
              aria-pressed={theme === 'dark'}
              aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
              title={`Switch to ${theme === 'light' ? 'dark' : 'light'} theme`}
            >
              <span className="theme-toggle__dot" aria-hidden="true" />
            </button>
          ) : null}
          <NavLink to="/valuation/prelisting" className="top-bar__cta">
            Value a property
          </NavLink>
        </div>
      </div>
    </header>
  );
}
